// This file configures the initialization of Sentry on the client.
// The config you add here will be used whenever a users loads a page in their browser.
// https://docs.sentry.io/platforms/javascript/guides/nextjs/

;globalThis["_sentryRouteManifest"] = "{\"dynamicRoutes\":[],\"staticRoutes\":[{\"path\":\"/\"},{\"path\":\"/clinics\"},{\"path\":\"/coaches\"},{\"path\":\"/country-admin\"},{\"path\":\"/dashboard\"},{\"path\":\"/diet-plans\"},{\"path\":\"/doctors\"},{\"path\":\"/forgot-password\"},{\"path\":\"/linking-request\"},{\"path\":\"/loader\"},{\"path\":\"/login\"},{\"path\":\"/patient\"},{\"path\":\"/patients\"},{\"path\":\"/profile\"},{\"path\":\"/reset-password\"},{\"path\":\"/updates\"}],\"isrRoutes\":[]}";globalThis["_sentryNextJsVersion"] = "15.5.7";import * as Sentry from "@sentry/nextjs";
import currentEnv from "./src/app/config/environment";

// Export the router transition hook for navigation instrumentation
export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;

const isQAEnvironment = currentEnv.currentInstance === 'qa';
const isProductionEnvironment = currentEnv.currentInstance === 'production';

// Initialize Sentry only in QA and Production environments
if ((isQAEnvironment || isProductionEnvironment) && process.env.NEXT_PUBLIC_SENTRY_DSN) {
  Sentry.init({
    dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
    
    environment: currentEnv.currentInstance,
    
    // Adjust sample rates based on environment
    tracesSampleRate: isQAEnvironment ? 1.0 : 0.1,
    
    // Enable debug in QA, disable in production
    debug: isQAEnvironment,
    
    // Session replay configuration
    replaysOnErrorSampleRate: isQAEnvironment ? 1.0 : 0.1,
    replaysSessionSampleRate: isQAEnvironment ? 0.5 : 0.1,
    
    integrations: [
      Sentry.replayIntegration({
        maskAllText: isProductionEnvironment,
        blockAllMedia: isProductionEnvironment,
      }),
    ],
  });
}